export default function ConfirmDialog({
  message,
  confirmLabel = "Delete",
  variant = "danger",
  onCancel,
  onConfirm,
}: {
  message: string;
  confirmLabel?: string;
  variant?: "danger" | "primary";
  onCancel: () => void;
  onConfirm: () => void;
}) {
  //Bestätigungsdialog
  const confirmClasses =
    variant === "danger"
      ? "bg-red-600 hover:bg-red-700"
      : "bg-dantzOrange hover:brightness-110";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
      <div className="w-full max-w-sm rounded-xl border border-secondary5 bg-white p-5 text-center shadow-sm">
        <p className="text-sm text-dantzBlue">{message}</p>
        <div className="mt-5 flex justify-center gap-3">
          <button
            onClick={onCancel}
            className="rounded-lg px-4 py-2 text-sm text-secondary4 hover:text-dantzBlue"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`rounded-lg px-4 py-2 text-sm font-medium text-white transition active:scale-[0.98] ${confirmClasses}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
